<template></template>
<script>
import { onMounted } from '@vue/runtime-core'
import { getCookie } from '@/utils/utils'
import { useRoute, useRouter } from 'vue-router'

export default {
  setup() {
    // const route = useRoute();
    const router = useRouter()
    const checkPath = () => {
      const hasLogin = sessionStorage.getItem('hasLogin')
      if (hasLogin === '1') {
        router.replace({ name: 'Home' })
      } else {
        router.replace({ name: 'Login' })
      }
    }
    onMounted(() => {
      checkPath()
    })
  },
}
</script>
